import { render, staticRenderFns } from "./ActorEditionForm.vue?vue&type=template&id=709c9670&"
import script from "./ActorEditionForm.vue?vue&type=script&lang=js&"
export * from "./ActorEditionForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports